/** @format */

import React, { FC } from "react";
import { Tag } from "antd";
import { TIntermittentStatus } from "../../../../redux-modules/declarations/maps/intermittentCommunications";
import { STATUS_META } from "../constants";

interface Props {
  status: TIntermittentStatus;
  label?: string;
}

export const StatusTag: FC<Props> = ({ status, label }) => {
  const meta = STATUS_META[status];

  return (
    <Tag color={meta?.color} icon={meta?.icon} style={{ borderRadius: 7, marginRight: 0 }}>
      {meta?.label || label || status}
    </Tag>
  );
};
